import React from "react"

const IconSearch = props => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.5 14.9171C9.2 14.9171 10.8 14.3204 12 13.4254L16.3 17.7017C16.5 17.9006 16.8 18 17 18C17.2 18 17.5 17.9006 17.7 17.7017C18.1 17.3039 18.1 16.7072 17.7 16.3094L13.5 11.9337C14.5 10.6409 15 9.14917 15 7.45856C15 3.38122 11.6 0 7.5 0C3.4 0 0 3.38122 0 7.45856C0 11.5359 3.4 14.9171 7.5 14.9171ZM7.5 1.98895C10.5 1.98895 13 4.47514 13 7.45856C13 10.442 10.5 12.9282 7.5 12.9282C4.5 12.9282 2 10.442 2 7.45856C2 4.47514 4.5 1.98895 7.5 1.98895Z" fill="currentColor" />
  </svg>
)

export default IconSearch
